import { render, staticRenderFns } from "./taskSummary.vue?vue&type=template&id=9d81bfd8&scoped=true"
import script from "./taskSummary.vue?vue&type=script&lang=js"
export * from "./taskSummary.vue?vue&type=script&lang=js"
import style0 from "./taskSummary.vue?vue&type=style&index=0&id=9d81bfd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d81bfd8",
  null
  
)

export default component.exports